import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import useResponsive from '@/hooks/useResponsive';
import { OrderEventWithIcon } from '@/types/parcel/orders/orderById.interface';
import { formatDate } from '@/utils/common';

import Evidence from './Evidence';

type OrderEventProps = OrderEventWithIcon;

const OrderEvent = ({ statusNameES, assets, eventTime, notes, status, Icon }: OrderEventProps) => {
  const isMobile = useResponsive('down', 'md');

  return (
    <Box
      sx={{
        padding: '0.5rem 0',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: '0.5rem',
        borderBottom: '1px solid #EAE7E7',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '0.5rem',
        }}
      >
        <Stack
          display="flex"
          flexDirection={isMobile ? 'column' : 'row'}
          alignItems={isMobile ? 'start' : 'center'}
          sx={{
            gap: '0.5rem',
            color: '#12344A',
            fontWeight: 'bold',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <Icon sx={{ width: '1rem', height: '1.1rem' }} />
            <Typography variant="body2" sx={{ fontWeight: 'bold', margin: '0 0.5rem 0 0' }}>
              {statusNameES}
            </Typography>
          </Box>
          {assets && assets.length > 0 && <Evidence evidences={assets} />}
        </Stack>
        <Typography
          variant="body1"
          sx={{
            margin: '0',
            width: '90px ',
            minWidth: '90px ',
          }}
        >
          {formatDate(eventTime)}
        </Typography>
      </Box>
      {['4002', '4101', '5101', '2101'].includes(status) && (
        <p style={{ fontWeight: 'normal', margin: '0 0.5rem 0 0' }}>{notes}</p>
      )}
    </Box>
  );
};

export default OrderEvent;
